import { makeStyles } from "@mui/styles";

export default makeStyles(({ palette, borders, typography, transitions, functions }) => {
  const { white, info, dark } = palette;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    alertContainer: {
      width: pxToRem(300),
      minHeight: pxToRem(50),
      backgroundColor: white.main,
      color: dark.main,
      borderRadius: borderRadius.md,
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: pxToRem(16),
      gap: pxToRem(8),
      transition: transitions.create(["transform", "opacity"], {
        duration: transitions.duration.standard,
        easing: transitions.easing.easeInOut,
      }),
    },
    info: {
      borderLeft: `${pxToRem(5)} solid ${info.main}`,
    },
    alertMessage: {
      ...typography.body2,
      flexGrow: 1,
    },
    alertClose: {
      cursor: "pointer",
      fontSize: pxToRem(20),
      color: dark.main,
      "&:hover": {
        color: info.main,
      },
    },
  };
});
